// Mede o espaço real da rotina: abas e filtros podem ocupar mais de uma linha.
// Grades internas de modais mantêm a altura definida pela própria tela.
function agendar(el) { el._alturaDisponivel?.agendar() }
export default {
  inserted(el, binding) {
    let frame
    const ajustar = () => {
      const main = el.closest('#main-content')
      if (!main || binding.value === false || el.closest('.modal, [role="dialog"], .produto-grid-interna')) return
      if (!el.getClientRects().length) return
      const topo = el.getBoundingClientRect().top + main.scrollTop
      const fundo = Math.min(main.getBoundingClientRect().bottom, window.innerHeight)
      const altura = `${Math.max(240, Math.floor(fundo - topo - 12))}px`
      if (el.style.height !== altura) el.style.height = altura
    }
    const agendar = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(ajustar) }
    const observer = new ResizeObserver(agendar)
    for (let parent = el.parentElement; parent; parent = parent.parentElement) observer.observe(parent)
    const tabs = document.getElementById('tab-content')
    if (tabs) observer.observe(tabs)
    window.addEventListener('resize', agendar)
    el._alturaDisponivel = { agendar, limpar() { observer.disconnect(); cancelAnimationFrame(frame); window.removeEventListener('resize', agendar) } }
    agendar()
  },
  componentUpdated: agendar,
  unbind(el) { el._alturaDisponivel?.limpar(); delete el._alturaDisponivel }
}
